import { has } from "shared/utils";
import { Show } from "shared/components";
import { pluralize } from "../../utils";
import { AuditSummaryFlag } from "../AuditSummaryFlag";
import { ApplicantOrInvitee, Verification } from "../../types";
import { EmptyCellIcon } from "./components/EmptyCellIcon";

interface EvictionReportContentProps {
  verification: Verification;
  applicant: ApplicantOrInvitee;
  hasAuditFlagEnabled: boolean;
}

export const EvictionReportContent = ({
  verification,
  applicant,
  hasAuditFlagEnabled
}: EvictionReportContentProps) => {
  if (has(verification.summary?.events_reported)) {
    const dismissedEventsReported =
      verification.summary.dismissed_events_reported ?? 0;

    return (
      <p className="text-content-1000">
        {verification.summary.events_reported}
        <Show if={dismissedEventsReported > 0}>
          <span className="text-content-100">
            {" "}
            ({dismissedEventsReported} dismissed{" "}
            {pluralize("eviction", dismissedEventsReported)})
          </span>
        </Show>
      </p>
    );
  }

  if (hasAuditFlagEnabled && "audit_summary_flags" in applicant)
    return (
      <AuditSummaryFlag audit_summary_flags={applicant.audit_summary_flags} />
    );

  return <EmptyCellIcon />;
};
